import { gql } from "@apollo/client";

export const CREATE_USER_CONFIRM = gql`
  mutation CreateUserConfirm($data: UserConfirmInput!) {
  createUserConfirm(data: $data) {
    id
  }
}
`;

export const CONFIRM_USER_ACCOUNT = gql`
  mutation ConfirmUserAccount($data: userConfirmInputV2!) {
    confirmUserAccount(data: $data) {
      message
      token
      userConfirm {
        id
        role
        email
        name
        phone
        psid
        addressCF
        isBlocked
        isDeleted
        account
        note
        image
        userAuthId
        createdAt
        updatedAt
      }
    }
  }
`;
export const CONFIRM_USER_AUTH = gql`
  mutation ConfirmUserAuth($token: String!) {
    confirmUserAuth(token: $token) {
      message
      token
      userConfirm {
        id
        role
        email
        name
        phone
        psid
        addressCF
        shop {
          id
        }
        isBlocked
        isDeleted
        account
        note
        image
        userAuthId
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_USER_CONFIRM = gql`
  mutation UpdateUserConfirm($data: UserConfirmInput!, $where: UserConfirmWhereInputOne!) {
    updateUserConfirm(data: $data, where: $where) {
      message
    }
}
`;

export const CUSTOMER_UPDATE_ORDER = gql`
  mutation CustomerUpdateOrderGroup($where: OrderGroupWhereInputOne!, $data: OrderGroupInput!) {
    customerUpdateOrderGroup(where: $where, data: $data) {
      dataOne {
        id
        amount
        phone
        address
        totalPrice
        sumPriceBaht
        sumPriceUsd
        sumPrice
        cfName
        customerName
        customerImage
        userFbId
        unsendMessage
        sendMessage
        tag
        tagColor
        code
        shipmentNumber
        shipPrice
        paymentType
        status
        invoiceStatus
        infulancerInvoiceStatus
        shopStatus
        payment
        isPaymented
        paySlip
        paySlips
        logistic
        originalLogistic
        destinationLogistic
        addressCf
        type
        isReply
        isDeleted
        createdAt
        updatedAt
        note
        transactionId
        infulancer_percent
        commissionAffiliate
        typeForAffiliate
        totalServiceCharge
        commissionService
        commissionInfluencer
        totalAffiliate
        isPaymentSupport
        isClaimBalance
        confirmBalance
        servicePaymentSupport
        jointOrder
        dataConfirmCod
        paymentMethod
        rate
      }
      msg
      status
    }
  }
`;
